import React from 'react';
import Footer from '../components/HomePageNew/Footer';
import MenuNew from '../components/MenuNew';
import Aide from '../components/HomePageNew/Aide';
import NavbarDrop from '../components/HomePageNew/NavbarDrop';
import ConfirmCompany from '../components/ConfirmCompany';


const ConfirmCompanyPage = () => {

  return (
    <div>
      <MenuNew />
      <NavbarDrop/>
      <ConfirmCompany />
      <Footer/>
      <Aide />
    </div>
  );
};

export default ConfirmCompanyPage;



/** WEBPACK FOOTER **
 ** ./src/containers/ConfirmCompanyPage.js
 **/